// Auth
export const CHECK_AUTH = "CHECK_AUTH";
export const LOGIN = "LOGIN";
export const LOGOUT = "LOGOUT";
export const REGISTER = "REGISTER";

// Settings
export const NAVBAR_STATE = "NAVBAR_STATE";
export const NAVBAR_TOGGLE = "NAVBAR_TOGGLE";
export const GET_CURRENT_SETTINGS = "GET_CURRENT_SETTINGS";
export const SAVE_SETTINGS = "SAVE_SETTINGS";

// Devices
export const FETCH_DEVICES = 'FETCH_DEVICES';
export const CREATE_DEVICE = 'CREATE_DEVICE';
export const UPDATE_DEVICE = 'UPDATE_DEVICE';
export const FETCH_SINGLE_DEVICE = 'FETCH_SINGLE_DEVICE';
export const RESET_SINGLE_DEVICE_STATE = 'RESET_SINGLE_DEVICE_STATE';
export const UPDATE_DEVICES_FILTER = 'UPDATE_DEVICES_FILTER';
export const DELETE_DEVICE = 'DELETE_DEVICE';
export const UPDATE_REFRESH_RATE = 'UPDATE_REFRESH_RATE';
export const FETCH_DEVICE_LOCATIONS = 'FETCH_DEVICE_LOCATIONS';
export const FETCH_DEVICE_MOVE_DETAILS = 'FETCH_DEVICE_MOVE_DETAILS';
export const FETCH_DEVICES_USAGE = 'FETCH_DEVICES_USAGE';
export const UPDATE_DEFAULT_DEVICE_REFRESH_RATE = 'UPDATE_DEFAULT_DEVICE_REFRESH_RATE';
export const RESET_DEVICE_FILTER = 'RESET_DEVICE_FILTER';

// Moves
export const FETCH_MOVES = 'FETCH_MOVES';
export const FILTER_MOVES = 'FILTER_MOVES';
export const RESET_MOVE_PARAMS = 'RESET_MOVE_PARAMS';
export const ASSIGN_DEVICE_TO_MOVE = 'ASSIGN_DEVICE_TO_MOVE';
export const REMOVE_DEVICE_FROM_MOVE = 'REMOVE_DEVICE_FROM_MOVE';

// Notifications
export const FETCH_NOTIFICATIONS = 'FETCH_NOTIFICATIONS';
export const LOAD_MORE_NOTIFICATIONS = 'LOAD_MORE_NOTIFICATIONS';
export const UPDATE_READ_STATUS = 'UPDATE_READ_STATUS';
export const RESET_NOTIFICATION_PARAMS = 'RESET_NOTIFICATION_PARAMS';
export const GET_NOT_READ_NOTIFICATIONS_COUNT = 'GET_NOT_READ_NOTIFICATIONS_COUNT';
